export default "__VITE_ASSET__a8e98f3d__"